    
<template>
    <a-spin :spinning="chartloading">
        <div class="dashBox">
            <div class="dashTitle">
                <a-select mode="default" v-model="chartPerTime" @change="handleChartPerTimeChange" style="width: 80px;float:right;margin-top:2px;" placeholder="请选择时间">
                <a-select-option v-for="(value,name) in perTimeValue" :key="name" :value="value">
                        {{name}}
                    </a-select-option>
                </a-select>
            </div>
            <a-empty v-if="chartData.triggerDayList.length == 0" description="暂无数据" style="margin-top:80px;" />
            <div id="jobChartID" style="width: 70%;padding-top:10px;float:left;"></div>

            <div id="jobPieID" style="width: 30%;padding-top:10px;float:left;"></div>

        </div>


    </a-spin>
</template>

<script>
const perTimeValue = {
    '今天':'1',
    '昨天':'2',
    '本周':'3',
    '上周':'4',
    '本月':'5',
    '上月':'6',
}
export default {
    data() {
        return {
            perTimeValue,
            chartData:{
                triggerCountFailTotal: 0,
                triggerCountRunningTotal: 0,
                triggerCountSucTotal: 0,
                triggerDayCountFailList: [],
                triggerDayCountRunningList: [],
                triggerDayCountSucList: [],
                triggerDayList:[]
            },
            chartloading:false,
            startDate:'',
            endDate:'',
            chartPerTime:'3',
            chartSys:null,
            chartPie:null,
        }
    },

    methods: {
        handleChartPerTimeChange(){
            this.loadData();
        },
        loadData(){
            let that = this;
            let tempData = that.G.getRecentDate(this.chartPerTime);
            that.startDate = new Date(tempData.start_time).Format('yyyy-MM-dd hh:mm:ss')
            that.endDate = new Date(tempData.end_time).Format('yyyy-MM-dd hh:mm:ss')

            that.chartloading = true;
            let params = {
                startDate:that.startDate,
                endDate:that.endDate,
                urlparams:false
            };
            that.$store.dispatch({
                type: "jobcenter/getchartInfo",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    console.log(res);
                    this.chartData = res.data.data.content;
                    that.analystData();
                    that.analystPie();
                }
                that.chartloading = false;
            }).catch(() => {
                that.chartloading = false;
            });
        },
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("jobChartID").style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById("jobChartID"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
            });
            
        },

        //按日期统计数据
        analystPie(){
            let that = this;
            if(that.chartPie){
                that.chartPie.clear();
            }
            document.getElementById("jobPieID").style.height = "360px";
            that.chartPie = that.$echarts.init(document.getElementById("jobPieID"));
            
            let option = that.getPieOption();
            // 窗口大小自适应方案
            that.chartPie.setOption(option);
            that.chartPie.off('click');
            that.chartPie.on('click', function () {
            });
            
        },
        getDatailOption(){
            let that = this;
            let option ={
                title : {
                    text: '日期分布图' ,
                    /*subtext: 'subtext',*/
                    x:'left'
                },
                tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {
                    data:['成功', '失败', '进行中']
                },
                toolbox: {
                    feature: {
                        /*saveAsImage: {}*/
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : that.chartData.triggerDayList
                    }
                ],
                yAxis : [
                    {
                        type : 'value'
                    }
                ],
                series : [
                    {
                        name:'成功',
                        type:'line',
                        stack: 'Total',
                        areaStyle: {normal: {}},
                        data: that.chartData.triggerDayCountSucList
                    },
                    {
                        name:'失败',
                        type:'line',
                        stack: 'Total',
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                        areaStyle: {normal: {}},
                        data: that.chartData.triggerDayCountFailList
                    },
                    {
                        name:'进行中',
                        type:'line',
                        stack: 'Total',
                        areaStyle: {normal: {}},
                        data: that.chartData.triggerDayCountRunningList
                    }
                ],
                color:['#00A65A', '#c23632', '#F39C12']
            }
            // let  colors = ['#5470C6', '#91CC75', '#EE6666'];

            return option;
        },
        getPieOption(){
            let that = this;
            let option ={
                title : {
                    text: '成功比例图' ,
                    /*subtext: 'subtext',*/
                    x:'center'
                },
                tooltip : {
                    trigger: 'item',
                    formatter: "{b} : {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: ['成功', '失败', '进行中' ]
                },
                series : [
                    {
                    //name: '分布比例',
                        type: 'pie',
                        radius : '55%',
                        center: ['50%', '60%'],
                        data:[
                            {
                                name:'成功',
                                value:that.chartData.triggerCountSucTotal
                            },
                            {
                                name:'失败',
                                value:that.chartData.triggerCountFailTotal
                            },
                            {
                                name:'进行中',
                                value:that.chartData.triggerCountRunningTotal
                            }
                        ],
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ],
                color:['#00A65A', '#c23632', '#F39C12']
            }
            // let  colors = ['#5470C6', '#91CC75', '#EE6666'];

            return option;
        },
        chartResize(){
            let eleArr = [this.chartSys,this.chartPie];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        this.loadData();
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },

}
</script>

<style scoped>

    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
        cursor: default;
    }
</style>
